import { render, staticRenderFns } from "./SeqFilesView.vue?vue&type=template&id=061af33c&"
import script from "./SeqFilesView.vue?vue&type=script&lang=js&"
export * from "./SeqFilesView.vue?vue&type=script&lang=js&"
import style0 from "./SeqFilesView.vue?vue&type=style&index=0&id=061af33c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports